import { Employee } from '../../services/EmployeeService'
import { TeamDetails, TeamStatus } from '../../services/TeamService'

const normalizeTeamsInput = (teams: TeamDetails[] | Record<string, TeamDetails> | null | undefined): TeamDetails[] => {
  if (!teams) return []
  if (Array.isArray(teams)) return teams
  if (typeof teams === 'object') return Object.values(teams)
  return []
}

export const flattenTeams = (teams: TeamDetails[] | Record<string, TeamDetails> | null | undefined): TeamDetails[] => {
  let flatTeams: TeamDetails[] = []
  const normalizedTeams = normalizeTeamsInput(teams)

  normalizedTeams.forEach(team => {
    flatTeams.push(team)

    if (team.children) {
      flatTeams = flatTeams.concat(flattenTeams(team.children as TeamDetails[] | Record<string, TeamDetails>))
    }
  })

  return flatTeams
}

export const getTeamsFromEmployees = (employees: Employee[]) => {
  const teams = employees.map(employee => (employee.teams && employee.teams[0]) || null).filter(team => team)
  return [...new Set(teams.map(a => JSON.stringify(a)))].map(a => JSON.parse(a))
}

export const getTeamStatusesFlags = (row: TeamStatus) => {
  const hasError = false
  const hasAlert = false
  const hasReviews = row?.finished && row?.finished > 0
  const finishedAllReviews = row?.finished === row?.teamSize
  const missesReviewsWithoutErrorsAndAlerts = hasReviews && !finishedAllReviews && !hasError && !hasAlert
  const finishedReviewsWithoutErrorsAndAlerts = finishedAllReviews && !hasError && !hasAlert
  return {
    hasError,
    hasAlert,
    hasReviews,
    finishedReviewsWithoutErrorsAndAlerts,
    missesReviewsWithoutErrorsAndAlerts,
  }
}
